import { render, staticRenderFns } from "./DocTransactions.vue?vue&type=template&id=41178074"
import script from "./DocTransactions.vue?vue&type=script&lang=js"
export * from "./DocTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports